import crayon from "../../../assests/Images/TemplateElement/crayon.png";
import duck from "../../../assests/Images/TemplateElement/duck.png";
import JoyLogo from "../../../assests/Images/TemplateElement/JoyBlueLogo.png";
import { DATE } from "../../../shared/constants.js";
import CardTemplate from "./CardTemplate";

export default function TextTemplateCyan({ heading, caption, date, journalId,pageRefresh,ref,menuShow }) {
  return (
    <CardTemplate
      journalId={journalId}
      headingText={heading || ""}
      bodyText={caption || ""}
      date={date || DATE.JOURNAL_FORMAT}
      bgColor="#0ae2cd"
      headingColor="#000000"
      textColor="#000000"
      borderColor="#005cff"
      imageTopLeft={crayon}
      imageTopLeftStyle={{
        width: { xs: 40, sm: 70, md: 70 },
        height: { xs: 40, sm: 70, md: 70 },
        top: 10,
        left: 10,
        transform: "rotate(150deg)",
      }}
      imageBottomLeft={duck}
      imageBottomLeftStyle={{
        width: { xs: 40, sm: 60, md: 60 },
        height: { xs: 40, sm: 60, md: 60 },
        bottom: { xs: 6, sm: 16, md: 16 },
        left: { xs: 0, sm: 10, md: 10 },
        transform: "scaleX(-1) rotateZ(45deg)",
      }}
      imageBottomRight={JoyLogo}
      imageBottomRightStyle={{
        width: { xs: 16, sm: 24, md: 24 },
        height: { xs: 16, sm: 24, md: 24 },
        bottom: { xs: 5, sm: 5, md: 5 },
        right: { xs: 5, sm: 5, md: 5 },
      }}
      pageRefreshCallback={pageRefresh}
      ref={ref}
      menuShow={menuShow}
    />
  );
}
